import React from 'react';
import OBSOLATE_GameScoreBoard from '../OBSOLATE_GameScoreBoard.js';
import {_GPY,__GPYPost,__GPYWeather} from '../../../env.js'
import GpyToggleButton from '../lib/GpyToggleButton.js';
import GpyTeamList from '../lib/GpyTeamList.js';
import Display from '../../display/Display.js';

import WaitCube from '../../../WaitCube'
import moment from 'moment';
import 'moment/locale/de';
import Casper from '../../Casper.js'
import arrayMove from 'array-move';

import { TwitterTimelineEmbed, TwitterShareButton, TwitterFollowButton, TwitterHashtagButton, TwitterMentionButton, TwitterTweetEmbed, TwitterMomentShare, TwitterDMButton, TwitterVideoEmbed, TwitterOnAirButton } from 'react-twitter-embed';
import ReactWeather from 'react-open-weather';
import * as rssParser from 'react-native-rss-parser';

class SBIncastContentTV extends OBSOLATE_GameScoreBoard {

	constructor(props) {

		super(props);
		this.files = {};
		var s = super.getGPYState("SBIncastContentTV");
		s.NAME = "SBIncastContentTV";
	  s.casparCGAdapterServer = "192.168.2.200";
		s.uiStateInView = "feed";
		s.playList=[];
		s.playPointer=0;
		s.playTime=0;
		s.playMaxTime=0;
		s.playLeft=0;
		s.playerStatus="stop";
		s.currentPlayingFile="unknown";
		s.pointOfIntrestsOffest = 0


		s.pointOfIntrests = [
			{ short:"AMS", title: "Amsterdam", localeCode: "Amsterdam,nl",  gmt:1, weather:{gpy_temp:"0",gpy_icon:"",gpy_title:"-"}},
			{ short:"ROM", title: "Rome", localeCode: "Rome,it" , gmt:1 , weather:{gpy_temp:"0",gpy_icon:"",gpy_title:"-"}},
			{ short:"LDN", title: "London", localeCode: "London,uk",  gmt:0, weather:{gpy_temp:"0",gpy_icon:"",gpy_title:"-"}},

			{ short:"GLA", title: "Glasgow", localeCode: "Glasgow,uk",  gmt:0, weather:{gpy_temp:"0",gpy_icon:"",gpy_title:"-"}},
			{ short:"DUB", title: "Dublin", localeCode: "Dublin,ie",  gmt:0, weather:{gpy_temp:"0",gpy_icon:"",gpy_title:"-"}},
			{ short:"COP", title: "Copenhagen", localeCode: "Copenhagen,dk",  gmt:1, weather:{gpy_temp:"0",gpy_icon:"",gpy_title:"-"}},

			{ short:"BAK", title: "Baku", localeCode: "Baku,az",  gmt:4, weather:{gpy_temp:"0",gpy_icon:"",gpy_title:"-"}},
			{ short:"BIL", title: "Bilbao", localeCode: "Bilbao,es",  gmt:1, weather:{gpy_temp:"0",gpy_icon:"",gpy_title:"-"}},
			{ short:"MUN", title: "Munich", localeCode: "Munich,de",  gmt:1, weather:{gpy_temp:"0",gpy_icon:"",gpy_title:"-"}},

			{ short:"SPE", title: "Saint Petersburg", localeCode: "Saint Petersburg,ru",  gmt:3, weather:{gpy_temp:"0",gpy_icon:"",gpy_title:"-"}},
			{ short:"BUD", title: "Budapest", localeCode: "Budapest,hu",  gmt:1, weather:{gpy_temp:"0",gpy_icon:"",gpy_title:"-"}},
			{ short:"BUC", title: "Bucharest", localeCode: "Bucharest,ro",  gmt:2, weather:{gpy_temp:"0",gpy_icon:"",gpy_title:"-"}},

			{ short:"BER", title: "Berlin", localeCode: "Berlin,DE",  gmt:1, weather:{gpy_temp:"0",gpy_icon:"",gpy_title:"-"}},
		];
		s.hometown = s.pointOfIntrests[0];

		s.mainContentPanel = [];
		s.mainContentPanelOffset = 0;
		s.flights =  {type:"flights", title: "", timestamp:0, data: []};

		s.sndContentPanel = [];
		s.sndContentPanelOffset = 0;

		s.trdContentPanel = [];
		s.trdContentPanelOffset = 0;

		s.casparDebugCMD="";

		s.dataStore = {};
		s.rssFeed = {};
		s.defaultDataStore = {};
		this.state = s;
	}

	doFilter(k){
		var filter = this.state.fileFilter;
		if ( filter === undefined || filter === "" ) {
			return true;
		}
		var key = k[1].name;
		return key.toLowerCase().includes(filter);
	}

	toCelsius(k) {
		return Math.floor(k) + "˚";  //Math.floor(k - 273.15) + "˚";
	}

	updateWeather() {


		var poi = this.state.pointOfIntrests;
		poi.map((p)=>{
			__GPYPost("getWeatherInfo",{localeCode:p.localeCode},(data)=>{
				data.gpy_temp = this.toCelsius(data.list[0].main.temp);
				data.gpy_title = data.list[0].weather[0].main;

				var prefix = 'wi-';
			  var code = data.list[0].weather[0].id;
	  		var icon = _GPY.weatherIcons[code].icon;
	  		if (!(code > 699 && code < 800) && !(code > 899 && code < 1000)) {
	    		icon = 'day-' + icon;
	  		}
	  		data.gpy_icon = "weather/" + prefix + icon + ".svg";
				data.gpy_label = _GPY.weatherIcons[code].label;

				var shortList = [];

				data.list.map((i)=>{
												i.gpy_temp = this.toCelsius(i.main.temp);
												i.gpy_title = i.weather[0].main;
												var _prefix = 'wi-';
												var _code = i.weather[0].id;
												var _icon = _GPY.weatherIcons[_code].icon;
												if (!(_code > 699 && _code < 800) && !(_code > 899 && _code < 1000)) {
													_icon = 'day-' + _icon;
												}
												i.gpy_icon = "weather/" + _prefix + _icon + ".svg";
												i.gpy_label = _GPY.weatherIcons[_code].label;
												var d = moment(i.dt*1000);
												i.gpy_time = d.format('DD.MM (HH:mm)');
				});

				for (var  i=0;i<data.list.length;i++){

					if(data.list[i].dt_txt.includes("09:00:00") ){
							shortList.push(data.list[i]);
					}
					if(data.list[i].dt_txt.includes("12:00:00")){
						if(shortList.length === 0) {
							shortList.push(data.list[0]);
						}
					 	 shortList.push(data.list[i]);
					}
					if(data.list[i].dt_txt.includes("18:00:00")){
						if(shortList.length === 0) {
							shortList.push(data.list[0]);
							shortList.push(data.list[0]);
							}
							shortList.push(data.list[i]);
					}
					if(data.list[i].dt_txt.includes("21:00:00")){
							if(shortList.length === 0) {
								shortList.push(data.list[0]);
								shortList.push(data.list[0]);
								shortList.push(data.list[0]);
							}
							shortList.push(data.list[i]);
					}
				}
				data.list = shortList.splice(0,16);

				p.weather=data;

				if(p.short === "BER") {
					this.loadRSS();
				};

			});
		});

		this.setState({pointOfIntrests:poi,hometown:poi[0]});
	}

	 _post(method,data,onSuccess,onFail) {
	  fetch(method, {
	     method: 'POST',
	     body: JSON.stringify(data!==undefined?data:{},_GPY.replacer),
	     credentials: 'include',
	     headers: {
	       'Accept': 'application/json',
	       'Content-Type': 'application/json',
	       'Cache-Control': 'no-cache, no-store, must-revalidate',
	       'Pragma': 'no-cache',
	       'Expires': '0',
	     },
	   })
	   .then(res => res.json())
	   .then((res) => {
	      if(res.Result !== undefined && res.Result.state === 'FATAL') {
	        window.location.reload(false);
	      }
	      if(onSuccess!==undefined){onSuccess(res);}
	    })
	   .catch((res) => {if(onFail!==undefined){onFail(res);}})
	}


	getFlydata() {
		var d = new Date('27 Nov 2019 06:00:00 GMT');
		var now = Math.round(new Date().getTime() / 1000);
		var res = {type:"flights", title: "flight", timestamp:0, data: []};
		this._post("http://192.168.2.140:8080/guppyi/json/getFlyInfo",{localeCode:now},(data)=>{
				res.title = data.result.response.airport.pluginData.details.name;
				/*
				console.log("(--------------------------------",data);
				console.log("(--------------------------------",data.result.response.airport.pluginData.details.name);
				console.log("(--------------------------------",data.result.response.airport.pluginData.schedule.departures.data);
				*/
				data.result.response.airport.pluginData.schedule.departures.data.map((i)=>{
						res.data.push(moment(i.flight.time.scheduled.departure*1000).format('DD.MM (HH:mm)')+"#TAB#"+i.flight.identification.number.default+"#TAB#"+i.flight.airport.destination.name+"#TAB#"+i.flight.airline.name+"#TAB#"+i.flight.status.text)
				});
				this.setState({flights:res});
		});

	}

	componentDidMount() {

		this.getFlydata();

		this.updateWeather();

	  super.getGamesStates();
		super.getLayouts();
		this.createConnection();

		this.weatherUpdateInteval = setInterval(() => {
			this.updateWeather();
	//		this.loadRSS();
		}, 360*1000);



		this.weatherUpdateInteval = setInterval(() => {
			this.updateWeather();
	//		this.loadRSS();
		}, 360*1000);


	  this.rssUpdateInteval = setInterval(() => {
     this.getFlydata();
	 }, 60*60*1000);

		this.loadRSS();

	}
	componentWillUnmount() {
		clearInterval(this.weatherUpdateInteval);
		clearInterval(this.rssUpdateInteval);
	}

	reloadCCGMedia() {
		var con = this.state.con;
		if(con!==undefined){
			console.log("CONNECTION:",con.readyState);
			 if(con.readyState === WebSocket.OPEN) {
				 con.send("FILE::./media");
			 }
		}
	}

	casparSend(cmd) {
		var con = this.state.con;
		if(con!==undefined){
			 console.log("CG Send:", cmd);
			 if(con.readyState === WebSocket.OPEN) {
				 con.send("CG::"+cmd);
			 }
		}
	}


	initDataStore(id) {
	}


	createConnection() {

		this.files={};
		this.setState({playList:[]});

		console.log("ws://"+this.state.casparCGAdapterServer+":5050/guppyicg/");
		var connection = new WebSocket("ws://"+this.state.casparCGAdapterServer+":5050/guppyicg/");
		connection.onopen =  () => {
				connection.send("FILE::./media");
				connection.send("CG::THUMBNAIL ALL");
		};

		connection.onerror = (error) => {
					console.log(error);
		};

		connection.onclose = (error) => {
		};

		connection.onmessage =  (e) => {

			var parts = e.data.split("::");
			if(parts[0]==="FILE") {

				var d = JSON.parse(parts[1])
				var o = {};
				d.files.map((f)=>{
					var n = f.name.split('.');
					f.id = n[0];
					o[f.id] = f;
					connection.send("CG::CINF "+n[0]);
				//  connection.send("CG::THUMBNAIL "+n[0]);
				});
				// this.setState({files:o});
			}
			if(parts[0]==="CG") {

					var firstLF = parts[1].indexOf("\n");
					var res = parts[1].substr(0,firstLF);
					var data = parts[1].substr(firstLF+1);

				//	console.log(firstLF,res,true,data);

					if(res === "201 INFO OK") {
							console.log("INFO");
							var parser = new DOMParser();
							var doc = parser.parseFromString(data, "text/xml");
				//		console.log(doc);

							var fileName = doc.evaluate( '//layer/foreground/producer/filename/text()', doc, null, XPathResult.STRING_TYPE, null ).stringValue;
							var fps = doc.evaluate( '//layer/foreground/producer/fps/text()', doc, null, XPathResult.NUMBER_TYPE, null ).numberValue;
							var frameNumber = doc.evaluate( '//layer/foreground/producer/frame-number/text()', doc, null, XPathResult.NUMBER_TYPE, null ).numberValue;
							var nbFrames = doc.evaluate( '//layer/foreground/producer/nb-frames/text()', doc, null, XPathResult.NUMBER_TYPE, null ).numberValue;

							var playTime = (frameNumber / fps);
							var playMaxTime = (nbFrames / fps);
							var playLeft = playMaxTime  - playTime;

				//			console.log(fps,frameNumber,nbFrames);
							var n = fileName.split('\\');
							if(n.length>=2) {
									var f = n[1].split('.');

									this.setState({playTime: playTime , playMaxTime: playMaxTime, playLeft: playLeft, currentPlayingFile:f[0]});
									var pl = this.state.playList;
							    var pointer = (this.state.playPointer);

									console.log(pl[pointer] , f[0]);
									if(pl[pointer].name === f[0]){
										pl[pointer].status="play";
									}
									if(5 > Math.floor(playLeft)) {
										this.loadNext();
									}
							}

					} else if(res === "200 CINF OK") {

			//				console.log("FILEINFO",data);
							var inf = data.split(" ");
							if(inf[1] === "MOVIE") {
							var key = inf[0].replace(/"/g,'');

							var files = this.files;
							files[key] = {};
							files[key].name = key;
							files[key].type = inf[1];
							files[key].seconds = 0;

							files[key].frames = parseInt(inf[4]);
							var framesPerSec = parseInt(inf[5].split("/")[1]);
							files[key].framesPerSecond = framesPerSec;
							files[key].seconds = this.files[key].frames / framesPerSec;

							this.forceUpdate();
					}
				}
			}
		}
		this.setState({con:connection});

	}

	disconnect() {

	}

	arrayRemove(arr,idx) {
		arr.splice(idx,1);
		return arr;
	}

	addToPlayList(item){
		var pl = this.state.playList;
		pl.push(item);
		item.status="queue";

		this.setState({playList:pl});
	}

	getPlayListTime(){
		var pl = this.state.playList;
		var sum = 0;
		pl.map((i)=>{
			sum += i.seconds;
		});
		return _GPY.secondsToTime(sum);
	}

	getPlayInfo(){
		this.casparSend("INFO 1-1");
	}

	loadNext() {
    var pl = this.state.playList;
    var pointer = (this.state.playPointer);
		if(pl[pointer].status==="loadToPlay") return;
		pl[pointer].status = "played";

    pointer++;
    if(pointer < pl.length) {
      this.casparSend("LOADBG 1-1 " + (pl[pointer].name) + " MIX 12 AUTO");
      pl[pointer].status = "loadToPlay";
      this.setState({playList:pl,playPointer:pointer});
    } else  {

			pl.map((i)=>{
				i.status = "queue";
			});
			pl[0].status = "loadToPlay";
			this.casparSend("LOADBG 1-1 " + (pl[0].name) + " MIX 12 AUTO");
			this.setState({playList:pl,playPointer:0});
		}
	}

	play () {
        var pl = this.state.playList;
        var pointer = (this.state.playPointer);
        this.casparSend("PLAY 1-1 " + (pl[pointer].name) + " MIX 12 AUTO");
        pl[pointer].status = "play";

        this.setState({playList:pl,playPointer:pointer,playerStatus:"play"},()=>{
          this.interval = setInterval(() => this.getPlayInfo(), (1000));
        });
  }

  stop(){
    clearInterval(this.interval);
		this.setState({playerStatus:"stop"});
    this.casparSend("STOP 1-1");
  }
  pause(){
    clearInterval(this.interval);
		this.setState({playerStatus:"pause"});
    this.casparSend("PAUSE 1-1");
  }
  resume(){
    this.casparSend("RESUME 1-1");
		this.setState({playerStatus:"play"});
    this.interval = setInterval(() => this.getPlayInfo(), (1000));
  }


	globalPause(){
		this.pause();

	  Object.keys(this.state.components).forEach(i => {
			if(this.state.components[i]!==undefined && this.state.components[i].isActive !== undefined && (this.state.components[i].isActive() || this.state.components[i].isRestartMode())) {
						this.state.components[i].pause();
			}
		});
	}

	globalResume(){
		this.resume();

		 Object.keys(this.state.components).forEach(i => {
			if(this.state.components[i]!==undefined && this.state.components[i].isActive !== undefined && this.state.components[i].isActive()) {
						this.state.components[i].resume();
			}
		});
	}

	skip() {
		if(this.state.playerStatus==="stop") {
			this.nextClip();
		}
	}

	nextClip() {
		var p = this.state.playPointer;
		var list = this.state.playList;
		if(p<list.length) {
			p++;
			this.setState({playPointer:p});
		}
	}

	addElementToNainContentPanel(element) {
	console.log("addElement ",element);
		var panel = this.state.mainContentPanel;
		panel.map((i)=>{
			if(element.type === i.type && element.title === i.title) {
				console.log("addElement EXIST");
				return;
			}
		});
		panel.unshift(element);
		this.setState({mainContentPanel:panel});
	}

	loadRSS(){

		fetch('https://www.uefa.com/rssfeed/news/rss.xml')
  		.then((response) => response.text())
  		.then((responseData) => rssParser.parse(responseData))
  		.then((rss) => {
				this.setState({rssFeed:rss},()=>{
										var content = [];
										var items = this.state.rssFeed.items
										if(items.length>3){
											items = items.slice(0,3);
										}
										items.map((i)=>{
											content.push( this.state.flights );
											content.push( {type:"news", title: "NEWS", timestamp:0, data:i} );
											content.push( {type:"time",image:undefined , title: "time" , timestamp:0 , data:{location:"Berlin",gmt:1}});
											content.push( {type:"weather",image: undefined , title: "Berlin" , timestamp:0 , data: this.state.pointOfIntrests[12].weather} );
										});
										this.setState({mainContentPanel:content});

										var snd = [];
										this.state.rssFeed.items.map((i)=>{
											snd.push( {type:"news", title: "NEWS", timestamp:0, data:i} );
										});
										this.setState({sndContentPanel:snd});
  		});
		});



		fetch('http://test.guppyi.com/?cat=2&feed=rss2')
	  	.then((response) => response.text())
	  	.then((responseData) => rssParser.parse(responseData))
  		.then((rss) => {
				this.setState({rssTrdFeed:rss},()=>{
										var trd = [];
										this.state.rssTrdFeed.items.map((i)=>{

											if(i.description.startsWith("<img") ) {
													var src = i.description.match(/\<img.+src\=(?:\"|\')(.+?)(?:\"|\')(?:.+?)\>/);
													console.log("########",i.description);

													i.description = _GPY.removeTags(i.description);
													src[1] = src[1].replace("-150x150","");
													i.image = src[1];

													console.log("######--", src[1]);
													var element = {type:"image_news",image: src[1] , title: i.title , timestamp:0 , data: i} ;
										  		this.addElementToNainContentPanel(element);

											} else {
												i.description = _GPY.removeTags(i.description);
												trd.push( {type:"news", title: "NEWS", timestamp:0, data:i} );
											}
										});

										if(JSON.stringify(trd) !== JSON.stringify(this.state.trdContentPanel)) {
												this.setState({trdContentPanel:trd},()=>{
													if(this.state.components.IncastContentTV_main_crawl!==undefined && this.state.components.IncastContentTV_main_crawl.isActive()) {
																this.state.components.IncastContentTV_main_crawl.updateData();
													}
												});
										}

  		});
		});

	}



	render () {
		const sponsorLogo = this.state.currentGame.sponsorLogo!==undefined&&this.state.currentGame.sponsorLogo!==''?this.state.currentGame.sponsorLogo:"empty.png";
		if(!this.state.defaultValuesLoaded) {
			return (<WaitCube/>);
		}

	  return (

			<div>

{/* **************** GAME ****************** */}

<div>

			<div className="row">

					<div className="col"  style={{backgroundColor:"#ff6",maxWidth:"15px"}}>
						<div className="verticaltext-content"><button className="btn btn-link" onClick={()=>{this.setState({uiStateInView:"feed"})}}>Guppyi - Newsfeed</button></div>
					</div>

			{this.state.uiStateInView === "feed"?

					<div className="col" style={{maxWidth:(this.state.displayWidth)+"px"}}>
		 					<div className="row">
										<div className="col-6" style={{maxWidth:(this.state.displayWidth)+"px"}}>
												 <div className="row">
																<div className="col-9 p-0">
																		<select className="form-control"  style={{zIndex:100}} onChange={super.changeLayout.bind(this)} value={this.state.currentLayout.id}>
																			<option key="-1" value="-1">default</option>
																			{this.state.layoutsIsLoaded ? this.state.layouts.map((t) =>
																				<option key={t.id} value={t.id}>{t.name}</option>
																			):""}
																		</select>
																</div>
																<div className="col-3  p-0 text-right">
																	<button type="button" className="btn btn-light btn-outline-dark btn-block" onClick={()=>{this.reset()}}>Reset</button>
																</div>
										   	  </div>
 													<div className="row">
																<div className="col-12 p-0 border border-white" style={{backgroundColor:"#ff6"}}>
																		<Display onData={(data,key)=>{super.onData(key,data);}} width={this.state.displayWidth} height={Math.round(this.state.displayWidth/1.7777777778)} layoutId={this.state.currentLayout.id} stateName="__DISPLAY__" scoreboard={this}/>
																</div>
													</div>
										</div>
								</div>


								<div className="row pt-2">
						 			<div className="col-4 pl-0 pr-1">

									<GpyToggleButton title="GuppyiCGLayer"
										onDeactivate={() => {
											this.casparSend("REMOVE 1-2");
											this.casparSend("REMOVE 2-2");

											return {visible: false}}}
										onActivate={() => {

											this.casparSend("PLAY 1-2 [HTML] "+ _GPY.displayUrl+"vbic1pyelijyysfjhhgz8xot");
											this.casparSend("PLAY 2-1 route://1-1");
											this.casparSend("PLAY 2-2 [HTML] "+ _GPY.displayUrl+"xjjm81prcpykdizoyqufdac0");

											return {visible: true}}}
										scoreboard={this}
										getTime={ () => {return 0;} }
										getGameId={() => {return -1} }
										stateName="XXX"
										/>
										</div>

										<div className="col-4  pl-1 pr-1">
										<GpyToggleButton title="ContentView"
											onDeactivate={() => {

												Object.keys(this.state.components).forEach(key => {
														var c = this.state.components[key];
														if(c !== undefined && key !== "IncastContentTV_content" && c['onDeactivate'] !== undefined){
															if(c['isActive']()) {
																 c['onDeactivate']();
															}
														}
												});


											this.casparSend("MIXER 1-1 FILL 0 0 1 1 25 easeinsine");
											this.casparSend("MIXER 2-1 FILL 0 0 1 1 25 easeinsine");
												return {visible: false}}}
											onActivate={() => {

						 					this.casparSend("MIXER 1-1 FILL 0.055 0.175 0.557 0.557 25 easeinsine");
											this.casparSend("MIXER 2-1 FILL 0.059 0.487 0.459 0.459 25 easeinsine");
												return { visible: true, hometown : this.state.hometown }}}
											scoreboard={this}
											getTime={ () => {return 0;} }
											getGameId={() => {return -1} }
											stateName="IncastContentTV_content"
											/>

						 			</div>
									<div className="col-4  pl-1 pr-0">
									<GpyToggleButton
											title="IBC Crawl"
											onInit={() => {return {}}}
											onDeactivate={() => {return {visible: false ,text: ""}}}
											onUpdateData={() => {
												var rss = "";
												this.state.rssTrdFeed.items.map((i)=>{
													rss = rss + i.title + " *** " + i.description + "\n";
												});
												return {text:rss}}
											}
											onActivate={() => {
												var rss = "";
												this.state.rssTrdFeed.items.map((i)=>{
													rss = rss + i.title + " *** " + i.description + "\n";
												});
												return {visible: true, text:rss,separatorImage: "uefa.png"}}}
											scoreboard={this}
											getTime={ () => {return 0;} }
											getGameId={() => {return -1} }
											stateName="IncastContentTV_main_crawl"/>

						 	   </div>


							 </div>
							 <div className="row pt-1">
							 <div className="col-4  pl-0 pr-1">
									 <GpyToggleButton
											 title="Top Clocks"
											 onInit={() => {return {}}}
											 onDeactivate={() => {
												 var offset = this.state.pointOfIntrestsOffest;
												 offset += 3;
												 this.setState({pointOfIntrestsOffest:offset});
												 return {visible: false}}}
											 onActivate={() => {
												 var offset = this.state.pointOfIntrestsOffest;
												 if(offset > 8) {
													offset = 0;
													this.setState({pointOfIntrestsOffest:offset});
												 }
												 var res = {visible: true,
													 left: this.state.pointOfIntrests[offset],
													 mid: this.state.pointOfIntrests[offset+1],
													 right: this.state.pointOfIntrests[offset+2],
												 }
												return res;
											 }}
											 scoreboard={this}
											 autoexpiryRestart="2000"
											 autoexpirytime="30"
											 getTime={ () => {return 0;} }
											 getGameId={() => {return -1} }
											 stateName="IncastContentTV_top_weather_clock"/>
 								 </div>

								 <div className="col-4  pl-1 pr-1">
										 <GpyToggleButton
												 title="Main Content"
												 onInit={() => {return {}}}
												 prepareRestart={()=> {
													 var offset = this.state.mainContentPanelOffset;
													 offset += 1;
													 this.setState({mainContentPanelOffset:offset});
												 }}
												 onDeactivate={() => {
													 return {visible: false}}}
												 onActivate={() => {
													 var offset = this.state.mainContentPanelOffset;
													 if(offset >= this.state.mainContentPanel.length) {
														offset = 0;
														this.setState({mainContentPanelOffset:offset});
													 }

													 var res = {visible: true,
														 content: this.state.mainContentPanel[offset],
													 }
													 return res;
												 }}
												 scoreboard={this}
												 autoexpiryRestart="1500"
												 autoexpirytime="16"
												 getTime={ () => {return 0;} }
												 getGameId={() => {return -1} }
												 stateName={()=> {
													 var offset = this.state.mainContentPanelOffset;
													 if(offset >= this.state.mainContentPanel.length) {
													 	offset = 0;
														this.setState({mainContentPanelOffset:offset});
													 }
													 return "IncastContentTV_main_content_" + this.state.mainContentPanel[offset].type;

												 }}/>
										 </div>


										 <div className="col-4  pl-1 pr-0">
												 <GpyToggleButton
														 title="UEFA Crawl"
														 onInit={() => {return {}}}
														 prepareRestart={()=> {
															 var offset = this.state.sndContentPanelOffset;
															 offset += 1;
															 this.setState({sndContentPanelOffset:offset});
														 }}
														 onDeactivate={() => {
															 return {visible: false}}}
														 onActivate={() => {
															 var offset = this.state.sndContentPanelOffset;
															 if(offset >= this.state.sndContentPanel.length) {
																offset = 0;
																this.setState({sndContentPanelOffset:offset});
															 }
																 var current = this.state.sndContentPanel[offset];
																 var v = [];
																 v[0] = current.data.title.substring(0,80);
																 v[1] = current.data.description.substring(0,80);

																 return {visible: true,text:v}
														 }}
														 scoreboard={this}
														 autoexpiryRestart="1500"
														 autoexpirytime="6"
														 getTime={ () => {return 0;} }
														 getGameId={() => {return -1} }
														 stateName="IncastContentTV_main_2nd_info"
														 />
												 </div>

						   </div>


							 <div className="row pt-1">
							 <div className="col-12  pl-0 pr-0">
									 <GpyToggleButton
											 title="LIVE INPUT"
											 onInit={() => {return {}}}
											 onDeactivate={() => {
												 this.globalResume();
												 this.casparSend("STOP 1-3 MIX 15 AUTO");
												 this.casparSend("STOP 2-3 MIX 15 AUTO");
												 return {visible: false}}}
											 onActivate={() => {
												 this.globalPause();
												 this.casparSend("PLAY 1-3 DECKLINK DEVICE 1 FORMAT 1080i5000 MIX 15 AUTO");
												 this.casparSend("PLAY 2-3 DECKLINK DEVICE 1 FORMAT 1080i5000 MIX 15 AUTO");
												 var res = {visible: true}
												 return res;
											 }}
											 scoreboard={this}
											 getTime={ () => {return 0;} }
											 getGameId={() => {return -1} }
											 stateName="IncastContentTV_LIVE"/>
								 </div>
		 				 </div>


							 <div className="row pt-1">
							 <div className="col-12  pl-0 pr-0">
							 		<GpyToggleButton
							 				title="PANIC"
							 				onInit={() => {return {}}}
							 				onDeactivate={() => {
												this.casparSend("CLEAR 1");
												this.casparSend("CLEAR 2");
							 					return {visible: false}}}
							 				onActivate={() => {
												this.reset();
												this.casparSend("CLEAR 1");
												this.casparSend("CLEAR 2");
							 					this.casparSend("PLAY 1 panic MIX 60 AUTO");
												this.casparSend("PLAY 2 panic MIX 60 AUTO");
							 					var res = {visible: true}
							 					return res;
							 				}}
							 				scoreboard={this}
							 				getTime={ () => {return 0;} }
							 				getGameId={() => {return -1} }
							 				stateName="IncastContentTV_PANIC"/>
							 	</div>


							 </div>



							 <div className="row pt-3">
									<div className="col-12 pl-0 pr-0 text-center">
											<span>Position: {_GPY.secondsToTime(this.state.playTime)} | Length: {_GPY.secondsToTime(this.state.playMaxTime)} | Duration: <strong> {_GPY.secondsToTime(this.state.playLeft)}</strong></span>
									</div>
							 </div>

							 <div className="row pt-1">
							 		<div className="col-12  pl-0 pr-0 text-center">
									<div class="btn-group btn-group-lg btn-group-block" role="group" aria-label="ClipActions">

										{this.state.playerStatus==="pause"||this.state.playerStatus==="stop"?
												<button className="btn btn-primary" onClick={()=>{this.state.playerStatus==="pause"?this.resume():this.play()}}><span class="glyphicon glyphicon-play" aria-hidden="true"></span></button>
										:
												<button className="btn btn-primary disabled" style={{cursor:"not-allowed"}}><span class="glyphicon glyphicon-play" aria-hidden="true"></span></button>
										}

										{this.state.playerStatus==="play"?
												<button className="btn btn-danger" onClick={()=>{this.stop()}}><span class="glyphicon glyphicon-stop" aria-hidden="true"></span></button>
										:
												<button className="btn btn-danger disabled" style={{cursor:"not-allowed"}}><span class="glyphicon glyphicon-stop" aria-hidden="true"></span></button>
										}

										{this.state.playerStatus==="play"?
												<button className="btn btn-info" onClick={()=>{this.pause()}}><span class="glyphicon glyphicon-pause" aria-hidden="true"></span></button>
										:
												<button className="btn btn-info disabled" style={{cursor:"not-allowed"}}><span class="glyphicon glyphicon-pause" aria-hidden="true"></span></button>
										}
										<button className="btn btn-info" onClick={()=>{this.skip()}}><span class="glyphicon glyphicon-step-forward" aria-hidden="true"></span></button>

									</div>

									</div>
						 	 </div>


							 <div className="row">
									<div className="col-12 pl-0 pr-0">
										<h3>Caspar</h3>
							 			<input type="text" className="form-control" onChange={(e)=>{this.setState({casparCGAdapterServer:e.target.value})}} value={this.state.casparCGAdapterServer}/>
										<button className="btn btn-light" onClick={()=>{this.createConnection()}}>Connect</button>
										<span className="text-small pl-3" >Status: {this.state.con!==undefined&&this.state.con.readyState===WebSocket.OPEN?"connected":"disconnect"}</span>
										<h5>debug</h5>
										<input type="text" className="form-control" onChange={(e)=>{this.setState({casparDebugCMD:e.target.value})}} value={this.state.casparDebugCMD}/>
										<button className="btn btn-light" onClick={()=>{this.casparSend(this.state.casparDebugCMD)}}>SEND</button>

							 </div>
						</div>
				   </div>


			:""}
		  {this.state.uiStateInView === "feed"?

					 <div className="col" >
							 <div className="row">


								 <div className="col w-20 pl-0">
								 		<div className="row">
												<div className="col-8 pr-0"><h5>Clips</h5></div>
												<div className="col-4 pr-0 text-right"><button className="btn btn-secondary" onClick={()=>this.state.con.send("FILE::./media")}><span class="glyphicon glyphicon-refresh" aria-hidden="true"></span></button></div>
										</div>
								 		<div className="row"><div className="col-12 pr-0"><input type="text" className="form-control" onFocus={(e)=>{e.target.select();}}  onChange={(e)=>{this.setState({fileFilter:e.target.value.toLowerCase()})}} placeholder="search"/></div></div>


										 <div className="row" style={{height: "750px",overflow:"scroll"}}>
												<div className="col-12 pr-0">
													<div className="list-group">

														 {Object.entries(this.files).filter((k)=>{ return this.doFilter(k) } ).map(([key,v],i) =>
													 		<div className="list-group-item">
															 <div className="row">

																<div className="col-6 p-0">
													 				<img style={{maxWidth : '100px', maxHeight : '50px'}}  src={"http://"+this.state.casparCGAdapterServer+":5050/"+key+".png"} className="img-fluid" alt="preview"/>
													 			</div>
																<div className="col-6 text-right">
																 <div class="btn-group" role="group" aria-label="ClipActions">
																  <button  data-toggle="tooltip" className="btn btn-light btn-sm" onClick={()=>{this.addToPlayList(v)}}><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button>
																 </div>
																</div>
															</div>


															<div className="row">
													 			<div className="col-12 p-0">
													 					<small><strong>{_GPY.secondsToTime(v.seconds)}</strong> : {key}</small>
													 				</div>
													  	</div>
													  </div>
														)}
		 										</div>
											</div>
										</div>
								 </div>













								 <div className="col w-20 pl-0">
			 							<div className="row text-center"><div className="col-12"><h5>Playlist {this.getPlayListTime()} ({this.state.playPointer})</h5></div></div>

			 							<div className="row">
			 									 <div className="col-12 pb-3 text-center">
			 											 <div class="btn-group" role="group" aria-label="Basic example">
			 													 <button className="btn btn-secondary" onClick={()=>this.loadRSS()}><span class="glyphicon glyphicon-refresh" aria-hidden="true"></span></button>
																 {this.state.playerStatus==="stop"?
																   <div>
			 													 		<button className="btn btn-secondary" onClick={()=>this.setState({playPointer: (this.state.playPointer<=0?this.state.playList.length-1:this.state.playPointer-1)})}><span class="glyphicon glyphicon-arrow-up" aria-hidden="true"></span></button>
			 													 		<button className="btn btn-secondary" onClick={()=>this.setState({playPointer: ((this.state.playPointer+1) < this.state.playList.length?this.state.playPointer+1:0)})}><span class="glyphicon glyphicon-arrow-down" aria-hidden="true"></span></button>
																 		<button className="btn btn-secondary" onClick={()=>this.setState({playPointer:0})}><span class="glyphicon glyphicon-collapse-up" aria-hidden="true"></span></button>
																	 </div>
																 :
																 	 <div>
																 		<button className="btn btn-secondary disabled"><span class="glyphicon glyphicon-arrow-up" aria-hidden="true"></span></button>
																 		<button className="btn btn-secondary disabled"><span class="glyphicon glyphicon-arrow-down" aria-hidden="true"></span></button>
																 		<button className="btn btn-secondary disabled"><span class="glyphicon glyphicon-collapse-up" aria-hidden="true"></span></button>
																	 </div>
															 	 }
			 											 </div>
			 									 </div>
			 							</div>


			 							<div className="row" style={{height: "750px",overflow:"scroll"}}>
			 								 <div className="col-12 pr-0">
			 									 <div className="list-group">
			 											{this.state.playList.map((i,idx)	 => {
			 												return (
			 													<div className={"list-group-item pt-0 pb-0"+(this.state.playPointer===idx?" list-group-item-success":"")}>
			 													<div className="row p-1">
			 														 <div className="col-4 p-0"><small><strong>{_GPY.secondsToTime(i.seconds)}</strong></small><br/><span style={{fontSize:"10px"}}>{i.status}</span></div>

			 														 <div className="col-8 p-0 text-right">

			 															 <div class="modal fade" id={"plyModal_"+idx} tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
			 																 <div class="modal-dialog" role="document">
			 																	 <div class="modal-content">
			 																		 <div class="modal-header">
			 																			 <h5 class="modal-title" id="exampleModalLongTitle">{i.name}</h5>
			 																			 <button type="button" class="close" data-dismiss="modal" aria-label="Close">
			 																				 <span aria-hidden="true">&times;</span>
			 																			 </button>
			 																		 </div>
			 																		 <div class="modal-body">
																					 			<img  src={"http://"+this.state.casparCGAdapterServer+":5050/"+i.name+".png"} className="img-fluid" alt="preview"/>
			 																		 </div>
			 																		 <div class="modal-footer">
			 																			 {/* <button type="button" class="btn btn-danger">REMOVE</button> */}
			 																			 <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
			 																		 </div>
			 																	 </div>
			 																 </div>
			 															 </div>

			 															 <div class="btn-group" role="group" aria-label="Basic example">
			 																 {i.status!=="play"&&i.status!=="loadToPlay"?
																			 		<button className="btn btn-sm btn-light" onClick={()=>this.setState({playPointer:idx})} ><span class="glyphicon glyphicon-play-circle" aria-hidden="true"></span></button>
																			:
																					<button className="btn btn-sm btn-light disabled"><span class="glyphicon glyphicon-play-circle" aria-hidden="true"></span></button>
																			}
			 																 <button className="btn btn-sm btn-light" data-toggle="modal" data-target={"#plyModal_"+idx}><span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span></button>
																				{i.status!=="play"&&i.status!=="loadToPlay"?
								 											   <button className="btn btn-light btn-sm" onClick={()=>{if(idx<this.state.playPointer){this.setState({playPointer:this.state.playPointer-1})} this.setState(({playList}) => ({playList: this.arrayRemove(playList,idx)}))}}><span class="glyphicon glyphicon-eject" aria-hidden="true"></span></button>
								 												:
																				 <button className="btn btn-light btn-sm disabled"><span class="glyphicon glyphicon-eject" aria-hidden="true"></span></button>
																				}
			 															 </div>

			 														 </div>


																	</div>

																	<div className="row">
																		 <div className="col-8 p-0 pb-1">
																		      <div className="row"><div className="col-12"><small>{i.name}</small></div></div>
																					<div className="row"><div className="col-12"><img style={{maxWidth : '100px', maxHeight : '50px'}}  src={"http://"+this.state.casparCGAdapterServer+":5050/"+i.name+".png"} className="img-fluid" alt="preview"/></div></div>
																		 </div>
																		 <div className="col-4 p-1 text-right">
																		 		<div className="row">
																			 			<div className="col-12">{i.status==="queue"||i.status==="played"?
																					 		<button  data-toggle="tooltip" className="btn btn-light btn-sm" onClick={()=>{if(idx>0)this.setState(({playList}) => ({playList: arrayMove(playList, idx, idx-1)}))}}><span class="glyphicon glyphicon-arrow-up" aria-hidden="true"></span></button>
																			     	:""}</div>
																				</div>
																				<div className="row">
																					 <div className="col-12">{i.status==="queue"||i.status==="played"?
																						 <button className="btn btn-light btn-sm" onClick={()=>{this.setState(({playList}) => ({playList: arrayMove(playList, idx, idx+1)}))}}><span class="glyphicon glyphicon-arrow-down" aria-hidden="true"></span></button>
																					 :""}</div>
																		 		</div>
																		 </div>
																	</div>
			 													</div>
			 											 );
			 										 })}
			 									 </div>
			 								 </div>
			 							</div>
			 					</div>












					<div className="col w-20 pl-0">
							<div className="row text-center"><div className="col-12"><h5>MainContent ({this.state.mainContentPanelOffset})</h5></div></div>

							<div className="row">
									 <div className="col-12 pb-3 text-center">
											 <div class="btn-group" role="group" aria-label="Basic example">
													 <button className="btn btn-secondary" onClick={()=>this.loadRSS()}><span class="glyphicon glyphicon-refresh" aria-hidden="true"></span></button>
													 <button className="btn btn-secondary" onClick={()=>this.setState({mainContentPanelOffset: (this.state.mainContentPanelOffset<=0?this.state.mainContentPanel.length-1:this.state.mainContentPanelOffset-1)})}><span class="glyphicon glyphicon-arrow-up" aria-hidden="true"></span></button>
													 <button className="btn btn-secondary" onClick={()=>this.setState({mainContentPanelOffset: ((this.state.mainContentPanelOffset+1) < this.state.mainContentPanel.length?this.state.mainContentPanelOffset+1:0)})}><span class="glyphicon glyphicon-arrow-down" aria-hidden="true"></span></button>
													 <button className="btn btn-secondary" onClick={()=>this.setState({mainContentPanelOffset:0})}><span class="glyphicon glyphicon-collapse-up" aria-hidden="true"></span></button>
											 </div>
									 </div>
							</div>


							<div className="row" style={{height: "750px",overflow:"scroll"}}>
								 <div className="col-12 pr-0">
									 <div className="list-group">
											{this.state.mainContentPanel.map((i,idx)	 => {
												return (
													<div className={"list-group-item pt-0 pb-0"+(this.state.mainContentPanelOffset===idx?" list-group-item-success":"")}>
													<div className="row p-1">
														 <div className="col-7 p-0"><small><strong>{i.title}</strong></small>
														 </div>
														 <div className="col-5 p-0 text-right">

															 <div class="modal fade" id={"mainModal_"+idx} tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
																 <div class="modal-dialog" role="document">
																	 <div class="modal-content">
																		 <div class="modal-header">
																			 <h5 class="modal-title" id="exampleModalLongTitle">{i.data.title}</h5>
																			 <button type="button" class="close" data-dismiss="modal" aria-label="Close">
																				 <span aria-hidden="true">&times;</span>
																			 </button>
																		 </div>
																		 <div class="modal-body">
																			 {i.data.description}
																		 </div>
																		 <div class="modal-footer">
																			 {/* <button type="button" class="btn btn-danger">REMOVE</button> */}
																			 <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
																		 </div>
																	 </div>
																 </div>
															 </div>

															 <div class="btn-group" role="group" aria-label="Basic example">
																 <button className="btn btn-sm btn-light" onClick={()=>this.setState({mainContentPanelOffset:idx})} ><span class="glyphicon glyphicon-play-circle" aria-hidden="true"></span></button>
																 <button className="btn btn-sm btn-light" data-toggle="modal" data-target={"#mainModal_"+idx}><span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span></button>
															 </div>

														 </div>
													 </div>
													</div>
											 );
										 })}
									 </div>
								 </div>
							</div>
					</div>












				<div className="col w-20 pl-0">
						<div className="row text-center"><div className="col-12"><h5>MainCrawl ({this.state.sndContentPanelOffset})</h5></div></div>

						<div className="row">
								 <div className="col-12 pb-3 text-center">
										 <div class="btn-group" role="group" aria-label="Basic example">
												 <button className="btn btn-secondary" onClick={()=>this.loadRSS()}><span class="glyphicon glyphicon-refresh" aria-hidden="true"></span></button>
												 <button className="btn btn-secondary" onClick={()=>this.setState({sndContentPanelOffset: (this.state.sndContentPanelOffset<=0?this.state.sndContentPanel.length-1:this.state.sndContentPanelOffset-1)})}><span class="glyphicon glyphicon-arrow-up" aria-hidden="true"></span></button>
												 <button className="btn btn-secondary" onClick={()=>this.setState({sndContentPanelOffset: ((this.state.sndContentPanelOffset+1) < this.state.sndContentPanel.length?this.state.sndContentPanelOffset+1:0)})}><span class="glyphicon glyphicon-arrow-down" aria-hidden="true"></span></button>
												 <button className="btn btn-secondary" onClick={()=>this.setState({sndContentPanelOffset:0})}><span class="glyphicon glyphicon-collapse-up" aria-hidden="true"></span></button>
										 </div>
								 </div>
						</div>


						<div className="row" style={{height: "750px",overflow:"scroll"}}>
							 <div className="col-12 pr-0">
								 <div className="list-group">
										{this.state.sndContentPanel.map((i,idx)	 => {
											return (
												<div className={"list-group-item pt-0 pb-0"+(this.state.sndContentPanelOffset===idx?" list-group-item-success":"")}>
												<div className="row p-1">
													 <div className="col-7 p-0"><small><strong>{i.title}</strong></small>
													 </div>
													 <div className="col-5 p-0 text-right">

														 <div class="modal fade" id={"sndModal_"+idx} tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
															 <div class="modal-dialog" role="document">
																 <div class="modal-content">
																	 <div class="modal-header">
																		 <h5 class="modal-title" id="exampleModalLongTitle">{i.data.title}</h5>
																		 <button type="button" class="close" data-dismiss="modal" aria-label="Close">
																			 <span aria-hidden="true">&times;</span>
																		 </button>
																	 </div>
																	 <div class="modal-body">
																		 {i.data.description}
																	 </div>
																	 <div class="modal-footer">
																		 {/* <button type="button" class="btn btn-danger">REMOVE</button> */}
																		 <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
																	 </div>
																 </div>
															 </div>
														 </div>

														 <div class="btn-group" role="group" aria-label="Basic example">
															 <button className="btn btn-sm btn-light" onClick={()=>this.setState({sndContentPanelOffset:idx})} ><span class="glyphicon glyphicon-play-circle" aria-hidden="true"></span></button>
															 <button className="btn btn-sm btn-light" data-toggle="modal" data-target={"#sndModal_"+idx}><span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span></button>
														 </div>

													 </div>
												 </div>
												</div>
										 );
									 })}
								 </div>
							 </div>
						</div>
				</div>














				 <div className="col w-20 pl-0">
						 <div className="row text-center"><div className="col-12"><h5>SecondCrawl ({this.state.trdContentPanelOffset})</h5></div></div>

						 <div className="row">
									<div className="col-12 pb-3 text-center">
											<div class="btn-group" role="group" aria-label="Basic example">
													<button className="btn btn-secondary" onClick={()=>this.loadRSS()}><span class="glyphicon glyphicon-refresh" aria-hidden="true"></span></button>
													<button className="btn btn-secondary" onClick={()=>this.setState({trdContentPanelOffset: (this.state.trdContentPanelOffset<=0?this.state.trdContentPanel.length-1:this.state.trdContentPanelOffset-1)})}><span class="glyphicon glyphicon-arrow-up" aria-hidden="true"></span></button>
													<button className="btn btn-secondary" onClick={()=>this.setState({trdContentPanelOffset: ((this.state.trdContentPanelOffset+1) < this.state.trdContentPanel.length?this.state.trdContentPanelOffset+1:0)})}><span class="glyphicon glyphicon-arrow-down" aria-hidden="true"></span></button>
													<button className="btn btn-secondary" onClick={()=>this.setState({trdContentPanelOffset:0})}><span class="glyphicon glyphicon-collapse-up" aria-hidden="true"></span></button>
											</div>
									</div>
						 </div>


						 <div className="row" style={{height: "750px",overflow:"scroll"}}>
								<div className="col-12 pr-0">
								  <div className="list-group">
										 {this.state.trdContentPanel.map((i,idx)	 => {
											 return (
												 <div className={"list-group-item pt-0 pb-0"+(this.state.trdContentPanelOffset===idx?" list-group-item-success":"")}>
												 <div className="row p-1">
														<div className="col-7 p-0"><small><strong>{i.title}</strong></small>
														</div>
														<div className="col-5 p-0 text-right">

															<div class="modal fade" id={"trdModal_"+idx} tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
															  <div class="modal-dialog" role="document">
															    <div class="modal-content">
															      <div class="modal-header">
															        <h5 class="modal-title" id="exampleModalLongTitle">{i.data.title}</h5>
															        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
															          <span aria-hidden="true">&times;</span>
															        </button>
															      </div>
															      <div class="modal-body">
																			{i.data.description}
															      </div>
															      <div class="modal-footer">
																			{/* <button type="button" class="btn btn-danger">REMOVE</button> */}
															        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
															      </div>
															    </div>
															  </div>
															</div>

															<div class="btn-group" role="group" aria-label="Basic example">
																<button className="btn btn-sm btn-light" onClick={()=>this.setState({trdContentPanelOffset:idx})} ><span class="glyphicon glyphicon-play-circle" aria-hidden="true"></span></button>
																<button className="btn btn-sm btn-light" data-toggle="modal" data-target={"#trdModal_"+idx}><span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span></button>
															</div>

														</div>
												  </div>
												 </div>
											);
										})}
							    </div>
						    </div>
		 		     </div>
	 		   </div>











							 </div>
					 </div>

			 :""}

  	 {/** this.state.uiStateInView === "feed"?
			 <div className="col"  style={{backgroundColor:"#ff6",maxWidth:"15px"}}>
			 	<div className="verticaltext-content">Guppyi - Scoreboard</div>
			 </div>
			:""}
			  {this.state.uiStateInView === "feed"?
		 			<div className="col-2">
		 					<div className="row">
		 								<div className="col-6 pl-4">
		 									SCOREBOARD
		 								</div>
		 					</div>
		 			 </div>
		 	 :"" **/}

			 <div className="col"  style={{backgroundColor:"#ff6",maxWidth:"15px"}}>
			 	<div className="verticaltext-content"><button className="btn btn-link" onClick={()=>{this.setState({uiStateInView:"contentSetup"})}}>Guppyi - Content Setup</button></div>
			 </div>
			 {this.state.uiStateInView === "contentSetup"?
		 			<div className="col-1">
		 					<div className="row">
		 								<div className="col-6">
										CONTENT
		 								</div>
		 					</div>
		 			 </div>
		 	 :""}

		</div>
	</div>



{/* **************** GAME ****************** */}
				 </div>

		);
    }

}
export default SBIncastContentTV;
